var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 16,
  viewBox: "0 0 21 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M0 15.984h20.593V0H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCA05",
  d: "M1.777 14.194h7.627V1.788H1.777z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#001246",
  d: "M11.189 14.194h7.627V1.788H11.19z"
}))));
export default SvgFlag;